export const isValidNumber = (input: string) => {
	const isEmptyOrWhitespace = /^\s*$/;
	return !isEmptyOrWhitespace.test(input) && !isNaN(Number(input));
};
